import {
  SAVE_CONTACT,
  SAVE_CONTACT_SUCCESS,
  SAVE_CONTACT_FAILURE
} from './actionTypes';

const initialState = {
  isSaving: false,
  contact: {},
  error: []
};

export const newContactReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_CONTACT:
      return { ...state, isSaving: true };
    case SAVE_CONTACT_SUCCESS:
      return { ...state, isSaving: false, contact: action.payload };
    case SAVE_CONTACT_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isSaving = state => state.newContact.isSaving;
export const getContact = state => state.newContact.contact;
export const getError = state => state.newContact.error;



// WEBPACK FOOTER //
// ./src/modules/ContactForm/reducer.js